/**
 * @file
 * Account scripts.
 */

// Equalize address book items.
let $profileListing = $('.profile-type-listing', context);
let $addProfileButton = $('.add-new-address', context);
let $addProfileForm = $('.profile-customer-add-form', context);
let closeBtnMarkup =
  '<button class="close-button" aria-label="Close form" type="button">×</button>';

// Equalize address book items, open offcanvas form.
$profileListing.once('profile-listing').each(function() {
  let $this = $(this);

  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-profiles');
  $this.attr({
    'data-equalizer': 'equalize-profiles',
    'data-equalize-on': 'small'
  });

  $addProfileForm.prepend(closeBtnMarkup);
  $addProfileForm.find('.close-button').click(function() {
    $addProfileForm.removeClass('is-active');
  });

  $addProfileButton
    .addClass('medium-6 large-4 columns views-row')
    .attr('data-equalizer-watch', 'equalize-profiles')
    .remove()
    .clone()
    .appendTo($this);

  $this.find('.add-new-address').click(function(e) {
    e.preventDefault();
    $addProfileForm.toggleClass('is-active');
  });

  $this.foundation();
});

// Equalize paymen method items.
let $paymentListing = $('.payment-method-listing', context);

$paymentListing.once('payment-listing').each(function() {
  let $this = $(this);

  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-payment');
  $this.attr({
    'data-equalizer': 'equalize-payment',
    'data-equalize-on': 'small'
  });

  $this.foundation();
});

// Equalize favorite products view.
let $favoriteProducts = $('.favorite-products-view', context);

$favoriteProducts.once('favorite-products').each(function() {
  let $this = $(this);

  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-favorites');
  $this.attr({
    'data-equalizer': 'equalize-favorites',
    'data-equalize-on': 'small'
  });

  $this.foundation();
});

// Add attributes to logout link to open popup window.
let $logout = $('.user-logout', context);

$logout.once('account-logout-link').each(function() {
  $(this)
    .attr('data-open', 'account-logout')
    .on('click', function(e) {
      // Prevent default click handler as Zurb's toggler handles it.
      e.preventDefault();
    });
});
